/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
export function ExportButton(props) {

    return(
        <button
    className={`z-10 select-none rounded-xl border-2 border-gray-800 shadow-md dark:shadow-stone-200 shadow-stone-800 px-2 min-h-full ${
         'bg-gray-100 text-gray-800'
    } hover:bg-gray-400 disabled:hover:bg-gray-100 transition-all focus:opacity-[0.85] disabled:opacity-30`}
    onClick={() => props.handle()}
    disabled={!props.isloaded}
    >
    <div className="flex flex-col items-center py-6">
        <img className="h-8 m-2" src="file.svg" alt="logo" />
        
        <div className="text-center text-blue-500">
        <h4 className="font-bold text-xl">Export Indeep<sup>Net</sup> file</h4>
        <small>Export an Indeep<sup>Net</sup> project file from the current state of your project</small> {/* Ajout d'une description */}
        </div>
    </div>
    </button>
        
    )
}

export function LinkButtonExport() {
    return(
        <a
  href="#"
  id="exporthref"
  className={`z-10 select-none rounded-xl border-2 border-gray-800 shadow-md dark:shadow-stone-200 shadow-stone-800 px-2 min-h-full ${
   'bg-gray-100 text-gray-800 disabled'
      
  } hover:bg-gray-400 transition-all focus:opacity-[0.85]`}
>
  <div className="flex flex-col items-center py-6">
    <img className="h-8 m-2" src="archive.svg" alt="logo" />
    
    <div className="text-center text-blue-500">
      <h4 className="font-bold text-xl">Export Data Archive</h4>
      <small>Export an archive containing all results for the current job</small>
    </div>
  </div>
</a>
    )
}